import { Location } from "../../../@types/DTO/Locations";

export function isTruthyLocationFlag(v: unknown): boolean {
  if (v === true) return true;
  if (typeof v === "number") return v === 1;
  if (typeof v === "string") {
    const s = v.toLowerCase().trim();
    return s === "true" || s === "1";
  }
  return false;
}

const COUNTRY_TO_ISO2: Record<string, string> = {
  ITALIA: "IT",
  FRANCIA: "FR",
  SPAGNA: "ES",
  GERMANIA: "DE",
  "REGNO UNITO": "GB",
  PORTOGALLO: "PT",
  MALTA: "MT",
  GRECIA: "GR",
  SVIZZERA: "CH",
  AUSTRIA: "AT",
  BELGIO: "BE",
  "PAESI BASSI": "NL",
  OLANDA: "NL",
  LUSSEMBURGO: "LU",
  IRLANDA: "IE",
  DANIMARCA: "DK",
  SVEZIA: "SE",
  NORVEGIA: "NO",
  FINLANDIA: "FI",
  POLONIA: "PL",
  "REPUBBLICA CECA": "CZ",
  SLOVACCHIA: "SK",
  UNGHERIA: "HU",
  ROMANIA: "RO",
  BULGARIA: "BG",
  CROAZIA: "HR",
  SLOVENIA: "SI",
  SERBIA: "RS",
  ALBANIA: "AL",
  "STATI UNITI": "US",
  CANADA: "CA",

  ITALY: "IT",
  FRANCE: "FR",
  SPAIN: "ES",
  GERMANY: "DE",
  "UNITED KINGDOM": "GB",
  PORTUGAL: "PT",
  GREECE: "GR",
  SWITZERLAND: "CH",
  BELGIUM: "BE",
  NETHERLANDS: "NL",
  LUXEMBOURG: "LU",
  IRELAND: "IE",
  DENMARK: "DK",
  SWEDEN: "SE",
  NORWAY: "NO",
  FINLAND: "FI",
  POLAND: "PL",
  "CZECH REPUBLIC": "CZ",
  SLOVAKIA: "SK",
  HUNGARY: "HU",
  CROATIA: "HR",
  "UNITED STATES": "US",
};

export function toShortCountry(country: string | undefined | null): string {
  if (!country) return "";
  const upper = country.trim().toUpperCase();
  if (!upper) return "";
  if (COUNTRY_TO_ISO2[upper]) return COUNTRY_TO_ISO2[upper];
  return upper.slice(0, 2);
}

export function formatLocationAddress(loc: Location): string {
  const streetLine = [loc.locationAddress, loc.locationNumber]
    .filter((v) => v && String(v).trim().length > 0)
    .join(" ")
    .trim();
  const country = toShortCountry(loc.country);
  return [streetLine, loc.locationCity, loc.zipCode, country]
    .filter((v) => v && String(v).trim().length > 0)
    .join(", ");
}
